import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c0902e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "frontend-icon fi-expand_less"
}
const _hoisted_2 = {
  key: 1,
  class: "frontend-icon fi-expand_more"
}

import { onBeforeUnmount, onMounted, ref } from 'vue';
  import Drop from "tether-drop";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'dropdown-menu',
  props: {
    position: {
      type: String,
      default: "bottom center",
    },
    additionalClasses: {
      type: String,
      default: "",
    },
  },
  setup(__props) {

  const props = __props;

  const dropInstance = ref<Drop | null>(null);
  const open = ref<boolean>(false);
  const root = ref<HTMLElement | null>(null);
  const submenu = ref<HTMLElement | null>(null);
  const handleArrowClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (root.value) {
      root.value.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    }
  };

  onMounted(() =>{
    ensureDropDestroy();
    dropInstance.value = new Drop({
      target: root.value ?? undefined,
      content: submenu.value ?? undefined,
      position: props.position,
      openOn: "click",
      remove: true,
      classes: props.additionalClasses,
    });
    dropInstance.value.on("open", () => {
      open.value = true;
    });
    dropInstance.value.on("close", () => {
      open.value = false;
    });
  })
    
  onBeforeUnmount(() =>{
    ensureDropDestroy();
  });

  const ensureDropDestroy = () => {
    if (dropInstance.value) {
      dropInstance.value.destroy();
      dropInstance.value = null;
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "components__dropdown-menu"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", {
      class: "dd-arrow",
      onClick: handleArrowClick
    }, [
      (open.value)
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : (_openBlock(), _createElementBlock("i", _hoisted_2))
    ]),
    _createElementVNode("div", {
      ref_key: "submenu",
      ref: submenu,
      class: "dd-submenu"
    }, [
      _renderSlot(_ctx.$slots, "submenu")
    ], 512)
  ], 512))
}
}

})